import React, { Component } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import ApiURL from "../../../api/ApiURL";

class IndividualIntervalsExample extends Component {
    
  render() {
    const flightnev1ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/lakshadweep-package-tour-with-flight-fly-91-from-goa.webp";
    const PM1ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/hon-pm-shri-narendra-modi-ji-at-lakshadweep-tour.webp";
    const PM2ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/hon-pm-shri-narendra-modi-ji-at-lakshadweep-trip.webp";
    const Sightseen1ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/lakshadweep-tour-package-booking-from-kochi.webp";
    const Sightseen2ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/lakshadweep-tour-packages-from-kochi.webp";
    const Sightseen3ImageURL = ApiURL.Lakshadweep_Package_4N_5D_ImageURL + "/lakshadweep-tour-travel-packages-from-kochi.webp";
    
    return (
      <Carousel fade>
        <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Sightseen1ImageURL}
          alt="Lakshadweep Package Tour from Kochi"
        />
          
        </Carousel.Item>
        <Carousel.Item interval={2000}>
        <img
          className="d-block w-100"
          src={PM1ImageURL}
          alt="Lakshadweep Package Tour from Kochi by Flight"
        />
        </Carousel.Item>
        <Carousel.Item>
        <img
          className="d-block w-100"
          src={flightnev1ImageURL}
          alt="Lakshadweep Package Tour from Cochin"
        />
        </Carousel.Item>
        <Carousel.Item>
        <img
          className="d-block w-100"
          src={Sightseen2ImageURL}
          alt="Lakshadweep Package Tour from Cochin by Flight"
        />
          
        </Carousel.Item>
        <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={PM2ImageURL}
          alt="Lakshadweep Trip Cost from Kochi"
        />
          
        </Carousel.Item>
        <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={Sightseen3ImageURL}
          alt="Lakshadweep Trip from Kochi"
        />
        </Carousel.Item>
        
      </Carousel>
    );
  }
}

export default IndividualIntervalsExample;
